import { createUrlWithSourceQueryParams } from '@crehana/analytics';
import { useTranslation } from '@crehana/i18n';
import { ArrowRight } from '@crehana/icons/outline';
import { Col, Container, Row, TextLink } from '@crehana/ui';

import { StyledH4, StyledSection } from './Banner.styles';

const Banner: React.FC = () => {
  const { t } = useTranslation();

  const registerUrl = createUrlWithSourceQueryParams({
    url: '/onboarding/',
    source: 'Homepage',
    sourceDetail: 'Banner',
  });

  return (
    // This color #ffe4a6 is harcoded because it belongs to the new ui kit
    <div style={{ backgroundColor: '#ffe4a6' }}>
      <StyledSection className="pt-52">
        <Container>
          <Row>
            <Col className="flex flex-col justify-center md:items-start lg:m-auto">
              <StyledH4 className="font-subtitle1 text-center md:text-left mb-20 sm:mb-24 sm:text-24 m-auto md:mr-auto md:ml-0">
                {t('BANNER_TITLE')}
              </StyledH4>
              <TextLink
                href={registerUrl}
                className="text-center md:text-left text-primary-main hover:text-primary-light"
                rightIcon={{ component: ArrowRight }}
              >
                {t('BANNER_LINK')}
              </TextLink>
            </Col>
          </Row>
        </Container>
      </StyledSection>
    </div>
  );
};

export default Banner;
